// ======================================================================
// File Name       : scoringReport
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../constants/actionTypes/scoringReport';
import * as ScoringReportConstants from '../constants/ScoringReportConstants';

const INITIAL_STATE = {
  modalReport: {},
  detailDrill: {},
  reportList: {
    mode: 'top',
    reportHistorySortType: 0,
    ascendingDescendingSort: 0,
    startPosition: 0,
  },
  searchResult: {
    recordNum: 0,
    reportList: [],
  },
  disabledButtonList: [],
  edittingReport: {},
};

export default function report(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.OPEN_REPORT_DIALOG: {
      const { data } = action;
      return {
        ...state,
        modalReport: { ...state.modalReport, ...data },
      };
    }
    case ActionTypes.REPORT_LIST_INIT_SEARCH_INFO: {
      const { data, isValidUrl, mode } = action;
      return {
        ...state,
        reportList: { ...state.reportList, ...{ data, isValidUrl, mode } },
      };
    }
    case ActionTypes.REPORT_LIST_GET_GROUP_LIST: {
      const { groupList } = action;
      return {
        ...state,
        reportList: { ...state.reportList, ...{ groupList } },
      };
    }
    case ActionTypes.REPORT_LIST_OPEN_GROUP_DIALOG: {
      const { reportList } = action;
      return { ...state, ...{ reportList } };
    }
    case ActionTypes.SELECTED_GROUP_FROM_DIALOG: {
      const { reportList } = action;
      return { ...state, ...{ reportList } };
    }
    case ActionTypes.SCORING_REPORT_SEARCH: {
      const { searchResult } = action;
      return { ...state, ...{ searchResult } };
    }
    case ActionTypes.UPDATE_SCORING_REPORT_SEARCH_CONDITION: {
      const { data } = action;
      return { ...state, reportList: { ...state.reportList, ...data } };
    }
    case ActionTypes.EDIT_BY_CORRECTOR: {
      // START #5056
      const { reportList, reportOperationType } = action.data;
      const disabledButtonList = [...state.disabledButtonList];
      if (reportList && reportList.length &&
        reportOperationType == ScoringReportConstants.REPORT_OPERATION_TYPE.COLLECT) {
        const indexOfReport = disabledButtonList.indexOf(reportList[0].toString());
        if (indexOfReport >= 0) {
          disabledButtonList.splice(indexOfReport, 1);
        }
      }
      // END #5056
      return {
        ...state,
        disabledButtonList,
      };
    }
    case ActionTypes.GET_DETAIL_DRILL: {
      const { data } = action;
      return {
        ...state,
        detailDrill: { ...state.detailDrill, ...data },
      };
    }
    case ActionTypes.RESET_DETAIL_DRILL: {
      const detailDrill = {};
      return { ...state, ...{ detailDrill } };
    }
    case ActionTypes.SAVE_MODAL_REPORT_DATA: {
      const { modalReport } = action;
      return {
        ...state,
        modalReport: { ...state.modalReport, ...modalReport },
      };
    }

    case ActionTypes.RESET_REPORT_LIST: {
      return {
        ...state,
        searchResult: {
          recordNum: 0,
          reportList: [],
        },
      };
    }

    case ActionTypes.DISABLE_GET_REPORT_BUTTON: {
      const { buttonId } = action;
      const disabledButtonList = [...state.disabledButtonList];
      const searchResult = { ...state.searchResult };
      searchResult.reportList.map((value) => {
        if (buttonId) {
          if (parseInt(buttonId, 10) === value.itemLearningHistoryReportIdAuto
              && value.reportStatus == ScoringReportConstants.REPORT_STATUS_ID.SUBMITTED) {
            value.isDisabled = true;
            disabledButtonList.push(buttonId);
          }
        }
      });
      return {
        ...state,
        searchResult,
        disabledButtonList,
      };
    }

    // #7404 START
    case ActionTypes.RECEIVED_DRILL_TOP_INFO: {
      const { data } = action;
      const { sankakuMarkSet, scoreForm, markRule, sankakuJudgeUseSet } = data;
      return {
        ...state,
        sankakuMarkSet,
        scoreForm,
        markRule,
        sankakuJudgeUseSet,
      };
    }

    case ActionTypes.RECEIVED_EACH_QUESTION: {
      const { data } = action;
      const { questionListOutput } = data;
      return {
        ...state,
        questionListOutput: questionListOutput && questionListOutput[0],
      };
    }
    // #7404 END

    default:
      return state;
  }
}
